import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=6edc6582&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"
import style0 from "./OrderPage.vue?vue&type=style&index=0&id=6edc6582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc6582",
  null
  
)

export default component.exports